module.exports = __webpack_public_path__ + "static/media/achievement-22.0a675c92.png";